<template>
    <div class="errors-page">
        <loader
            v-if="loading"
            :cover="true"
        />
        <div class="title">
            <h1>{{ trans('pages.errors.title') }}</h1>
            <ui5-button>
                <i
                    class="fa fa-plus"
                    @click="errors.push('')"
                />
            </ui5-button>
        </div>
        <div
            v-if="errors"
            class="errors"
        >
            <div
                class="error-item"
                v-for="(error, index) in errors"
            >
                <ui5-input
                    :value="errors[index]"
                    @input="
                        errors[index] = $event.target.value;
                        $forceUpdate();
                    "
                />
                <i
                    class="fa fa-remove"
                    @click="$delete(errors, index)"
                />
            </div>
        </div>
        <div class="bottom-row">
            <ui5-button @click="save()">
                <div>
                    <spinner v-if="saving" />
                    <template>{{ trans('pages.errors.save') }}</template>
                </div>
            </ui5-button>
        </div>
    </div>
</template>
<style
    scoped
    lang="scss"
>
.errors-page {
    .title {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .errors {
        display: flex;
        flex-direction: column;
        gap: 8px;

        .error-item {
            display: flex;
            gap: 8px;
            align-items: center;

            ui5-input {
                width: auto;
                min-width: auto;
                flex: 1;
            }

            i {
                cursor: pointer;
            }
        }
    }

    .bottom-row {
        display: flex;
        margin-top: 20px;
        justify-content: flex-end;

        ui5-button {
            div {
                display: flex;
                gap: 8px;
            }
        }
    }
}
</style>
<script>
import Loader from '../components/loader/Loader';
import Spinner from '../components/loader/Spinner';
import errorReportErrorApi from '../api/errorReportError';
import { showErrorMessage } from '../dialogs';
import localization from '../mixins/localization';

export default {
    mixins: [localization],
    methods: {
        save() {
            this.saving = true;
            errorReportErrorApi
                .save(this.errors)
                .catch(() => {
                    showErrorMessage(
                        this.trans('pages.errors.unknown_save_error')
                    );
                })
                .finally(() => {
                    this.saving = false;
                });
        },
    },
    mounted() {
        this.loading = true;
        errorReportErrorApi
            .fetchAll()
            .then((response) => {
                this.errors = response.data.data;
            })
            .catch(() => {
                showErrorMessage(
                    this.trans('pages.errors.unknown_fetch_error')
                );
            })
            .finally(() => {
                this.loading = false;
            });
    },
    data() {
        return {
            loading: false,
            saving: false,
            errors: null,
        };
    },
    components: {
        Spinner,
        Loader,
    },
};
</script>
